<template>
  <modal-pro></modal-pro>
  <product-hero
    :bg="require('@/assets/banner-products.jpg')"
    code="<span class='colored'>PS</span>"
    :title="$t('products.psTitle')"
  ></product-hero>
  <product-line-item
    v-for="(item, idx) in products"
    :key="idx"
    :img="item.img"
    :name="item.name"
    :tagline="item.tagline"
    :slug="item.slug"
  ></product-line-item>
</template>

<script>
import ProductHero from "./../../components/ProductHero.vue";
import ProductLineItem from "./../../components/ProductLineItem.vue";
import ModalPro from "./../../components/ModalPro.vue";
import productDetails from "./../../data/productDetails.js";

export default {
  name: "PS",
  components : { ProductHero, ProductLineItem, ModalPro },
  computed : {
    contentLocale() {
      return this.$store.state.region === "us" ? "us" : this.$i18n.locale;
    },
    products() {
      const items = [];

      if (this.$store.state.region !== "us") {
        items.push({
          img : productDetails.hickory.icon || productDetails.hickory.heroImg,
          name : productDetails.hickory.name,
          tagline : this.$t("hickory.tagline", this.contentLocale),
          slug : productDetails.hickory.slug
        });
      }

      items.push({
        img : productDetails.cypress.icon || productDetails.cypress.heroImg,
        name : productDetails.cypress.name,
        tagline : this.$t("cypress.tagline", this.contentLocale),
        slug : productDetails.cypress.slug
      });

      items.push({
        img : productDetails.oak.icon || productDetails.oak.heroImg,
        name : productDetails.oak.name,
        tagline : this.$t("oak.tagline", this.contentLocale),
        slug : productDetails.oak.slug
      });

      items.push({
        img : productDetails.cement.icon || productDetails.cement.heroImg,
        name : this.$t("cement.title"),
        tagline : this.$t("cement.tagline", this.contentLocale),
        slug : productDetails.cement.slug
      });

      return items;
    }
  }
}
</script>
